import martin from "../../assets/team/ejere/martin-wolder.jpg";
import thomas from "../../assets/team/ejere/thomas-vilhelmsen.jpg";
import mikkel from "../../assets/team/ejere/mikkel-munk.jpg";
import allan from "../../assets/team/ejere/allan-lyckegaard.jpg";

export default function EjereGrid() {
  return (
    <section className="container mx-auto mt-[-60px] md:mt-[-160px]">
      <div className="mx-auto max-w-screen-xl">
        <div className="grid gap-x-20 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          <div className="items-center mb-24 md:mb-0">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={thomas}
              alt="Thomas Vilhelmsen - Doctio"
            />
            <div>
              <h3 className="text-dlg font-bold text-doctio-green pt-4 mb-0">
                Thomas Vilhelmsen
              </h3>
              <h4 className="text-dbase mb-8 font-bold">
                Medstifter og medejer af Doctio
              </h4>
              <p className="text-dbase">
                Thomas blev uddannet læge i 2019. Siden har han stiftet
                bekendskab med specialerne: akutmedicin, almen medicin, anæstesi
                og militærlæge.
              </p>
            </div>
          </div>
          <div className="items-center mb-24 md:mb-0">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={mikkel}
              alt="Mikkel Munk - Doctio"
            />

            <div>
              <h3 className="text-dlg font-bold text-doctio-green pt-4 mb-0">
                Mikkel Munk
              </h3>
              <h4 className="text-dbase mb-8 font-bold">
                Medstifter og medejer af Doctio
              </h4>
              <p className="text-dbase ">
                Mikkel blev uddannet læge i 2019. Har han stiftet bekendskab med
                specialerne: ortopædkirurgi, neurologi, intern medicin, almen
                medicin og anæstesi.
              </p>
            </div>
          </div>
          <div className="items-center mb-24 md:mb-0">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={allan}
              alt="Allan Lyckegaard - Doctio"
            />

            <div>
              <h3 className="text-dlg font-bold text-doctio-green pt-4 mb-0">
                Allan Lyckegaard
              </h3>
              <h4 className="text-dbase mb-8 font-bold">
                Medstifter og medejer af Doctio
              </h4>
              <p className="text-dbase ">
                Allan er civilingeniør fra 2007 og har en Ph.D. fra 2011. Han
                har mere end 10 års erfaring med på softwareudvikling,
                dataanalyse, cloudbaserede løsninger og løsninger til den
                offentlige sektor.
              </p>
            </div>
          </div>
          <div className="items-center">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={martin}
              alt="Martin Wolder - Doctio"
            />

            <div>
              <h3 className="text-dlg font-bold text-doctio-green pt-4 mb-0">
                Martin Wolder
              </h3>
              <h4 className="text-dbase mb-8 font-bold">
                Medstifter og medejer af Doctio
              </h4>
              <p className="text-dbase ">
                Martin blev uddannet læge i 2020. Siden har han stiftet
                bekendskab med specialerne: ortopædkirurgi, thoraxkirurgi, almen
                medicin, intern medicin, øre-næse-halskirurgi, kardiologi og
                anæstesi.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
